import "./DashboardHeader.css";

function DashboardHeader() {
  return <>
    <div className="heading">Dashboard</div>
    <div className="info-text dashboard-info-text">You can check the client overview data here</div>
  </>;
}

export default DashboardHeader;